import { request } from "../util/request";

const uploadProductosImperdonables = async (body) => {
  const { data } = await request.post("/v2/Product/LoadNewFocusProducts", body);
  return data;
};

const uploadProductosBonificacion = async (body) => {
  const { data } = await request.post("/v2/Product/LoadNewBonificacionProducts", body);
  return data;
};

const uploadClientes = async (body) => {
  const { data } = await request.post("/v2/Cliente/LoadClientes", body);
  return data;
};

const uploadProductoIniciativa = async (body) => {
  const { data } = await request.post("/v2/Product/LoadInitiativeProduct", body);
  return data;
};

const uploadDescuentoPersonalizado = async (body) => {
  const { data } = await request.post("/v2/Product/LoadCustomDiscount", body);
  return data;
};

const uploadProductoSugerido = async (body) => {
  const { data } = await request.post("/v2/Product/LoadSuggestedProducts", body);
  return data;
};

const uploadProductoFrecuente = async (body) => {
  const { data } = await request.post("/v2/Product/LoadFrequentProducts", body);
  return data;
};

const uploadProductoComboFijo = async (body) => {
  const { data } = await request.post("/v2/Product/LoadFixedBundleProducts", body);
  return data;
};

const uploadProductoComboVariable = async (body) => {
  const { data } = await request.post("/v2/Product/LoadVariableBundleProducts", body);
  return data;
};

export const serviceMaestroCarga = {
  uploadProductosImperdonables,
  uploadProductosBonificacion,
  uploadClientes,
  uploadProductoIniciativa,
  uploadDescuentoPersonalizado,
  uploadProductoSugerido,
  uploadProductoFrecuente,
  uploadProductoComboFijo,
  uploadProductoComboVariable,
};
